import { SxProps, Theme } from '@mui/system';

const styles = {
  professionalName: {
    fontSize: 20,
    fontWeight: '600',
    mb: 2,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
